// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"317":"7259f6bb","950":"114cda8e"}[chunkId] + ".chunk.js";
};